export default __webpack_public_path__ + "static/media/journalEmpty.4e84fde8.svg";